import { Component } from 'opus-angular-seed-core';

import plusIcon from 'lucide-static/icons/plus.svg';
import xIcon from 'lucide-static/icons/x.svg';

/**
 * Keyword filter for the application log search.
 *
 * The user starts with a single keyword box and can add more (up to maxKeywords).
 * Every box can be set to include (default) or exclude and, apart from the first
 * one, be removed. Boxes are stacked under each other.
 */
@Component({
    bindings: {
        keywords: '=',
        logFiles: '=',
        maxKeywords: '<',
        loading: '<',
        onSearch: '&'
    },
    template: `
        <div class="table-filters">
            <form ng-submit="vm.search()" class="form form-filter">
                <div class="application-log-filters">
                <div class="fields application-log-keywords">
                    <div class="items application-log-keyword" ng-repeat="keyword in vm.keywords track by $index">
                        <select
                            class="form-control application-log-keyword-mode"
                            ng-model="keyword.exclude"
                            ng-options="mode.value as (mode.label | translate) for mode in vm.modes"
                        ></select>
                        <input
                            type="text"
                            class="form-control application-log-keyword-value"
                            ng-model="keyword.value"
                            placeholder="{{ 'applicationLog.Keyword' | translate }}"
                        >
                        <button
                            type="button"
                            class="btn discrete application-log-keyword-add"
                            ng-if="$last"
                            ng-disabled="vm.keywords.length >= vm.maxKeywords"
                            title="{{ 'applicationLog.Add keyword' | translate }}"
                            ng-click="vm.addKeyword()"
                            ng-bind-html="vm.plusIcon"
                        ></button>
                        <button
                            type="button"
                            class="btn discrete application-log-keyword-remove"
                            ng-if="$index > 0"
                            title="{{ 'applicationLog.Remove keyword' | translate }}"
                            ng-click="vm.removeKeyword($index)"
                            ng-bind-html="vm.removeIcon"
                        ></button>
                    </div>
                </div>
                <div class="application-log-files" ng-if="vm.logFiles.length">
                    <label class="label">{{ 'applicationLog.Log files' | translate }}</label>
                    <label class="items application-log-file" ng-repeat="logFile in vm.logFiles track by logFile.id">
                        <span class="switch01">
                            <input type="checkbox" ng-model="logFile.selected">
                            <span></span>
                        </span>
                        <span class="application-log-file-date">
                            {{ logFile.date }}<span ng-if="logFile.active"> ({{ 'applicationLog.today' | translate }})</span>
                        </span>
                        <span class="application-log-file-size">{{ vm.formatSize(logFile.size) }}</span>
                    </label>
                </div>
                </div>
                <ul class="actions01">
                    <li>
                        <input
                            type="submit"
                            class="btn main"
                            ng-disabled="vm.loading"
                            value="{{ 'applicationLog.Search' | translate }}"
                        >
                    </li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($sce) {
        this.$sce = $sce;
    }

    $onInit () {
        this.modes = [
            { value: false, label: 'applicationLog.Include' },
            { value: true, label: 'applicationLog.Exclude' }
        ];
        this.plusIcon = this.$sce.trustAsHtml(plusIcon);
        this.removeIcon = this.$sce.trustAsHtml(xIcon);
    }

    addKeyword () {
        if (this.keywords.length >= this.maxKeywords) {
            return;
        }
        this.keywords.push({ value: '', exclude: false });
    }

    removeKeyword (index) {
        if (index === 0) {
            return;
        }
        this.keywords.splice(index, 1);
    }

    /**
     * Formats a file size in bytes into a short human readable string (e.g. "3.2 GB").
     */
    formatSize (bytes) {
        if (!bytes || bytes < 0) {
            return '0 B';
        }
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let size = bytes;
        let unit = 0;
        while (size >= 1024 && unit < units.length - 1) {
            size /= 1024;
            unit++;
        }
        const rounded = unit === 0 ? size : Math.round(size * 10) / 10;
        return `${rounded} ${units[unit]}`;
    }

    search () {
        this.onSearch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/applicationlog/filter/index.js